import { render } from "./BonusShow.vue?vue&type=template&id=e888fc1c&scoped=true"
import script from "./BonusShow.vue?vue&type=script&lang=js"
export * from "./BonusShow.vue?vue&type=script&lang=js"

import "./BonusShow.vue?vue&type=style&index=0&id=e888fc1c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e888fc1c"]])

export default __exports__